module.exports = __webpack_public_path__ + "static/media/5.Sewage Mud pump.a34fd5be.jpeg";